import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
const Icon = styled.svg`
  width: 25px;
  height: 25px;
`;

const ArticleIcon = ({
  height
}) => /*#__PURE__*/React.createElement(Icon, {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg",
  width: "25",
  height: height,
  "aria-label": "artikel"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "evenodd",
  d: "M3,4 L19,4 L19,7 L3,7 L3,4 Z M3,10 L21,10 L21,13 L3,13 L3,10 Z M3,16 L17,16 L17,19 L3,19 L3,16 Z"
}));

ArticleIcon.propTypes = {
  height: PropTypes.string
};
ArticleIcon.defaultProps = {
  height: '25'
};
export default ArticleIcon;